import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';
import { IconArrowRight } from '$partials/icon/index.js';
import { isLocalURL } from '$utilities/browser';
import { Media } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').LargeCta}
 */
const LargeCta = ({
    backgroundColour,
    ctaLabel,
    ctaLink,
    heading,
    media,
    modulePaddingClasses = '',
    text
}) => {
    const href = formatLinkBlockToUrl(ctaLink);
    const isExternal = href && !isLocalURL(href);

    return (
        <section className='module-large-cta'>
            <div className={`layout-container ${modulePaddingClasses}${backgroundColour ? ' bg-' + backgroundColour : ''}`}>
                <div className='layout-grid flex-col sm:flex-row gap-y-16 sm:gap-y-0'>
                    <div className='w-full sm:w-4/12 lg:w-3/12 layout-grid-col flex flex-col items-start gap-y-8'>
                        {heading && (
                            <h2 className='type-style-heading'>{heading}</h2>
                        )}

                        {text && (
                            <div
                                className='rich-text type-style-body'
                                dangerouslySetInnerHTML={{ __html: text }} />
                        )}

                        {(ctaLabel && href) && (
                            <p className='mt-20'>
                                <a
                                    className='button type-style-body cursor-pointer'
                                    href={href}
                                    rel={isExternal ? 'noopener noreferrer' : undefined}
                                    target={isExternal ? '_blank' : undefined}>
                                    {ctaLabel}

                                    <span
                                        aria-hidden={true}
                                        className='ml-5'>
                                        <IconArrowRight
                                            height={20}
                                            width={20} />
                                    </span>
                                </a>
                            </p>
                        )}
                    </div>

                    {media && (
                        <div className='w-full sm:w-8/12 layout-grid-col text-[0] leading-[0] tracking-normal'>
                            <figure className={media.videoEmbed ? '' : 'pointer-events-none select-none'}>
                                <Media
                                    image={media.image ? { ...media.image } : undefined}
                                    video={media.video ? {
                                        autoPlay: true,
                                        controls: false,
                                        loop: true,
                                        muted: true,
                                        ...media.video
                                    } : undefined}
                                    videoEmbed={media.videoEmbed ? { ...media.videoEmbed } : undefined} />
                            </figure>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default LargeCta;
